export enum screens {
  home = "home",
  progressPhotos = "progressPhotos",
  contactUs = "contactUs",
  backToWebsite = "backToWebsite",
  logout = "logout",
  login = "login",
  selectJob = "selectJob",
  changePassword = "changePassword"
}
